<template>
  <div v-if="loadingData !== null && loadingData !== undefined">
    <v-dialog scrollable v-model="loading" persistent max-width="400">
      <v-card>
        <v-card-title>
          {{ $t("components.membersmanagementtable.please_wait") }}
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.add" persistent max-width="1400">
      <material-card
      :title="$t('components.membersimportwizardcomponent.create_new_member')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <add-member-wizard
            :inDialog="true"
            v-if="dialogs.add"
            ref="addMemberWizard"
            :headers="headers"
            @valid-changed="addMemberWizardValid = $event"
            @new-member-saved="
              dialogs.add = false;
              $refs.table.getDataAsync();
            "
          ></add-member-wizard>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              $refs.addMemberWizard.tryReleaseCertificate();
              dialogs.add = false;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="$refs.addMemberWizard && $refs.addMemberWizard.saving"
            :disabled="!addMemberWizardValid"
            color="primary"
            @click="$refs.addMemberWizard.save()"
          >
            {{ $t("globals.finish") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.createMassNotes"
      persistent
      max-width="1400"
      v-if="dialogs.createMassNotes"
    >
      <material-card
        :title="$t('components.addmemberwizard.create_mass_notes')"
        :color="$vuetify.theme.themes.light.success"
        icon="note"
      >
        <v-card-text>
          <create-mass-notes-form
            ref="createMassNotesForm"
            @valid="massNotesValid = $event"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="dialogs.createMassNotes = false"
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="createMassNotesHandler"
            :disabled="!massNotesValid"
          >
            {{ $t("components.addmemberwizard.create_mass_notes") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
      :title="$t('components.membersmanagementtable.members')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="folder_shared"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="computedFloatActions"
        @itemsChanged="setData($event)"
        fileNamePrefix="members"
        :identifier="identifier"
        :noSearch="true"
        :showSelect="false"
        @error="error = $event"
      ></pbas-data-table>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ $t(message) }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
    </material-card>

    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import AddMemberWizard from "../components/AddMemberWizard";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import { locker } from "../mixins/locker";
import CreateMassNotesForm from "@/components/MembersTable/CreateMassNotesForm";

export default {
  name: "members-management-table",
  components: {
    AddMemberWizard,
    ErrorHandler,
    CreateMassNotesForm,
  },
  mixins: [locker],
  props: ["expandable", "odataUrl", "headersFunc", "identifier", "term"],
  data() {
    return {
      panel: [0, 1],
      searchForm: {
        firstName: null,
        lastName: null,
        certificate: null,
        sin: null,
      },
      addMemberWizardValid: true,
      error: null,
      provider: undefined,
      floatActions: [],
      rowActions: [
        {
          name: "viewItem",
          icon: "visibility",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            //console.log(item);

            this.$router.push({ name: "memberView", params: { id: item.Id } });
          },
          visible: (item) => {
            return item;
          },
        },
        // {
        //   name: "viewDependants",
        //   icon: "edit",
        //   title: "components.memberview.viewedit_dependants",
        //   handler: (item) => this.viewDependants(item),
        //   visible: () => {
        //     return (
        //       this.headers.filter(
        //         (o) =>
        //           o.propertyGroup ===
        //           this.columnsDropDownOptions.Enums.MemberPropertyGroup.indexOf(
        //             "DependantsSection"
        //           )
        //       ).length > 0
        //     );
        //   },
        // },
      ],
      dialogs: {
        add: false,
        createMassNotes: false,
      },
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: [],
      computedFloatActions: [],
      loading: false,
      massNotesValid: false,
      loadingData: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["role"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    url: function() {
      if (this.odataUrl !== null && this.odataUrl !== undefined)
        return this.odataUrl;
      return "plans/" + this.selectedPlan.Id + "/members";
    },
  },
  async created() {
    window.addEventListener("beforeunload", this.unload, { capture: true });
    // window.addEventListener('unload', this.unload, {capture: true});
    // document.addEventListener("visibilitychange",this.unload);
    await this.loadPlanData();
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unload, { capture: true });
  },
  async mounted() {
    
    this.computedFloatActions = this.floatActions.concat([]);
    if (this.selectedPlan.PlanType === "HW") {
      this.computedFloatActions.push({
        name: "exportMembers",
        icon: "people",
        color: this.$vuetify.theme.themes.light.primary,
        text: "pbascomponents.pbasdatatable.download_members",
        handler: this.exportMembers,
      });
    }
    if (
      this.role.indexOf("Broker Plan Manager") > -1 ||
      this.role.indexOf("Broker Plan Admin") > -1 ||
      this.role.indexOf("Employer Plan Admin") > -1
    ) {
      this.computedFloatActions.unshift({
        name: "addMember",
        icon: "add",
        color: this.$vuetify.theme.themes.light.success,
        text: "globals.add_new",
        handler: this.add,
      });
      if (this.headers.filter((o) => o.text === "SIN").length > 0) {
        this.computedFloatActions.push({
          name: "createMassNotes",
          icon: "note",
          color: this.$vuetify.theme.themes.light.success,
          text: "components.addmemberwizard.create_mass_notes",
          handler: () => {
            this.dialogs.createMassNotes = true;
          },
        });
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    try {
      await this.$refs.addMemberWizard.tryReleaseCertificate();
    } catch (error) {
      this.error = error;
    }
    next();
  },
  methods: {
    ...mapActions("plansMembers", [
      "getMembersManagementColumns",
      "lockWizard",
      "getBlobAsyncPost",
      "createMassMemberNotes",
    ]),
    ...mapActions("common", ["createOdataType"]),
    async unload() {
      console.log("unload");
      if (this.$refs.addMemberWizard) {
        try {
          await this.$refs.addMemberWizard.tryReleaseCertificate();
          console.log("Hello");
          this.sleep(1000);
          console.log("World!");
        } catch (error) {
          this.error = error;
        }
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },
    // generateDependantProvider(item) {
    //   const url =
    //     "plans/" +
    //     this.selectedPlan.Id +
    //     "/members/" +
    //     this.dependantItem.IdentityId +
    //     "/dependants/" +
    //     item.IdentityId +
    //     "/history";
    //   return new PbasOData(
    //     this.$axiosHttp,
    //     url,
    //     this.dependantsHeaders.filter(
    //       (o) =>
    //         (o.visible === true && o.allowVisibilityChange === true) ||
    //         o.allowVisibilityChange === false
    //     )
    //   );
    // },
    async loadPlanData(filter = null) {
      this.loadingData = true;
      try {
        let headers;
        if (this.headersFunc !== null && this.headersFunc !== undefined) {
          headers = await this.headersFunc();
        } else {
          headers = (await this.getMembersManagementColumns(
            this.selectedPlan.Id
          )).data.sort((a, b) => {
            return a.order - b.order;
          });
        }

        if (headers.length === 0) {
          this.error = {
            customMessage: this.$t("errors.no_headers"),
          };
          return;
        }

        //TODO PATCH FOR DEMO - DELETE
        let flagsColumn = headers.find(function(el) {
          return el.text == "FlagsTranslations";
        });
        // if (flagsColumn) {
          headers = headers.filter(function(el) {
            return el.text != "FlagsTranslations";
          });
          headers.unshift(flagsColumn);
        // }

        //TODO END PATCH

        this.headers = headers;
        const h2 = this.$helpers.createOdataHeaders(
          headers.filter((h) => {
            // console.log(h);
            return h.showOnExpandOnly !== true;
          }),
          "headers.members_management."
        );
        //console.log(h2.map(i => i.title))
        //console.log(h2.filter(o=>o.value.indexOf("MemberGroup") > -1));
        console.log("headers", h2, headers);
        if (!filter) {
          this.$nextTick(()=>{
            this.provider = new PbasOData(this.$axiosHttp, this.url, h2);
          })
          
        } else {
          const pr = new PbasOData(this.$axiosHttp, this.url, h2);
          pr.filter = filter;
          this.provider = pr;
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingData = false;
      }
    },
    async submitSearchForm() {
      const filters = [];
      this.provider.filter = undefined;
      if (this.searchForm.firstName) {
        filters.push(
          `tolower(CurrentMember/FirstName) eq '${this.searchForm.firstName.toLowerCase()}'`
        );
      }
      if (this.searchForm.lastName) {
        filters.push(
          `tolower(CurrentMember/LastName) eq '${this.searchForm.lastName.toLowerCase()}'`
        );
      }
      if (this.searchForm.certificate) {
        filters.push(
          `MemberIdentification/Certificate eq '${this.searchForm.certificate}'`
        );
      }
      if (this.searchForm.sin) {
        filters.push(`MemberIdentification/SIN eq '${this.searchForm.sin}'`);
      }
      if (filters.length > 0) {
        this.provider.filter = filters.join(" and ");
      }
      this.$refs.table.getDataAsync();
      //await this.loadPlanData(filters.join(" and "));
    },
    setData(items) {
      this.$emit("setMembers", items);
      // for (let item of items) {
      //   if (item.TerminatedAt) {

      //   }
      // }
    },
    async exportMembers() {
      this.loading = true;
      const url = "plans/" + this.selectedPlan.Id + "/member-export";

      const filename = "Members.xlsx";
      let columns = this.headers.filter(
        (c) =>
          this.provider.headers.filter(
            (h) => h.visible === true && h.type.key === c.value
          ).length > 0
      );
      console.log(columns);
      try {
        let blob = (await this.getBlobAsyncPost({
          url: url,
          filename: filename,
          payload: columns.map((o) =>
            this.$t("headers.members_management." + o.text)
          ),
        })).data;

        const url2 = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", filename); //or any other extension
        link.setAttribute("id", "link1"); //or any other extension
        document.body.appendChild(link);
        link.click();
        var element = document.getElementById("link1");
        element.parentNode.removeChild(element);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    // async viewDependants(item) {
    //   this.dependantItem = item;
    //   this.dependantsProvider = new PbasOData(
    //     this.$axiosHttp,
    //     this.dependantUrl,
    //     this.dependantsHeaders
    //   );
    //   this.dialogs.viewDependants = true;
    // },

    async add() {
      try {
        await this.lock(
          this.lockWizard,
          {
            plan: this.selectedPlan.Id,
            dialogs: this.dialogs,
            dialog: "add",
          },
          () => {
            this.dialogs.add = false;
          }
        );
        this.dialogs.add = true;
      } catch (error) {
        this.error = error;
      }
    },
    async createMassNotesHandler() {
      this.error = null;
      this.saving = true;
      try {
        await this.createMassMemberNotes({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            SINs: this.$refs.createMassNotesForm.sins
              .split(",")
              .filter((o) => o !== ""),
            Note: this.$refs.createMassNotesForm.note,
          },
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.createMassNotes = false;
      } catch (e) {
        console.error(e);
        this.error = e;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style>
.background-red {
  background-color: red;
}
.background-green {
  background-color: green;
}
.full-width {
  width: 100%;
}
.terminated {
  background-color: red;
}
</style>
